<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form
      class="form"
      :class="submitting ? 'is-submitting' : ''"
      @submit.prevent="handleSubmit(submit)"
    >
      <div class="form__error" v-if="serverError">{{ serverError }}</div>

      <div class="form__fields">
        <b-vee-input
          rules="required|email"
          type="email"
          :label="$t('Email')"
          v-model="fields.email"
          :placeholder="$t('email@domain.com')"
        />

        <b-vee-input
          rules="required"
          type="password"
          :label="$t('Password')"
          v-model="fields.password"
        />
      </div>

      <div class="u-df u-jcsb u-aic">
        <span @click="handleRecoverPwLinkClick" class="t-link t-link--dark">
          {{ $t("Recuperar password") }}</span
        >

        <b-button
          :loading="submitting"
          native-type="submit"
          type="is-primary"
          size="is-medium"
          >{{ $t("Entrar") }}</b-button
        >
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import store from "@/store";

import { ValidationObserver } from "vee-validate";
import BVeeInput from "./buefy-vee-fields/BVeeInput";

export default {
  components: {
    ValidationObserver,
    BVeeInput,
  },

  data() {
    return {
      serverError: null,
      submitting: false,

      fields: {
        email: "",
        password: "",
      },
    };
  },

  methods: {
    handleRecoverPwLinkClick() {
      this.$emit("switchToResetPw");
    },

    submit() {
      this.submitting = true;
      this.serverError = null;

      store
        .dispatch("login", { ...this.fields })
        .then(() => {
          this.$emit("success");
        })
        .catch((error) => {
          try {
            this.serverError = error.message;
          } catch (err) {
            this.serverError = "Erro não definido";
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
